import { APICallV2Post } from './APICall';

export class TrashbinEmptyApiCall extends APICallV2Post {
    _method = 'trashbin/empty';
}
